module.exports = __webpack_public_path__ + "img/logo-revs-negro-394x137.78f200a0.png";